export const SERVICE_HOTELS = "S1";
export const SERVICE_CIRCUITS = "S2";
export const SERVICE_DAYTRIPS = "S3";
export const SERVICE_TOURS = "S4";
export const SERVICE_INTERNATIONAL = "S5";
export const SERVICE_FLIGHTS = "S6";
export const SERVICE_OTHERS = "S7";
export const SERVICE_PACKAGED = "S8";
export const SERVICE_TRANSFERS = "S9";
export const SERVICE_LOCKEDS = "S10";
export const SERVICE_GROUPS = "S11";

export const SERVICE_TYPE_BY_ID = {
    SERVICE_HOTELS: 1,
    SERVICE_CIRCUITS: 2,
    SERVICE_DAYTRIPS: 3,
    SERVICE_TOURS: 4,
    SERVICE_INTERNATIONAL: 5,
    SERVICE_FLIGHTS: 6,
    SERVICE_OTHERS: 7,
    SERVICE_PACKAGED: 8,
    SERVICE_TRANSFERS: 9,
    SERVICE_LOCKEDS: 10,
    SERVICE_GROUPS: 11
};

export function SERVICE_TITLE(service) {
    let name = "";
    switch (service) {
        case SERVICE_HOTELS:
            name = 'Hoteles';
            break;
        case SERVICE_CIRCUITS:
            name = 'Circuitos';
            break;
        case SERVICE_DAYTRIPS:
            name = 'Pasadías';
            break;
        case SERVICE_TOURS:
            name = 'Tours';
            break;
        case SERVICE_INTERNATIONAL:
            name = 'Internacionales';
            break;
        case SERVICE_FLIGHTS:
            name = 'Vuelos';
            break;
        case SERVICE_PACKAGED:
            name = 'Empaquetados';
            break;
        case SERVICE_TRANSFERS:
            name = 'Traslados';
            break;
        case SERVICE_LOCKEDS:
            name = 'Bloqueos';
            break;
        case SERVICE_GROUPS:
            name = 'Grupos';
            break;
        default:
            name = 'Otros servicios'
            break;
    }

    return name;
}

export function SERVICE_SLUG(service) {
    let slug = "";
    switch (service) {
        case SERVICE_HOTELS:
            slug = 'hotels';
            break;
        case SERVICE_CIRCUITS:
            slug = 'circuits';
            break;
        case SERVICE_DAYTRIPS:
            slug = 'daytrips';
            break;
        case SERVICE_TOURS:
            slug = 'tours';
            break;
        case SERVICE_INTERNATIONAL:
            slug = 'internationals';
            break;
        case SERVICE_FLIGHTS:
            slug = 'flights';
            break;
        case SERVICE_PACKAGED:
            slug = 'packaged';
            break;
        case SERVICE_TRANSFERS:
            slug = 'traslados';
            break;
        case SERVICE_LOCKEDS:
            slug = 'lockeds';
            break;
        case SERVICE_GROUPS:
            slug = 'lockeds';
            break;
        default:
            slug = 'other-services'
            break;
    }

    return slug;
}

export const LIST_SERVICE_TYPE = [
    {
        id: SERVICE_HOTELS,
        name: SERVICE_TITLE(SERVICE_HOTELS),
    },
    {
        id: SERVICE_CIRCUITS,
        name: SERVICE_TITLE(SERVICE_CIRCUITS),
    },
    {
        id: SERVICE_DAYTRIPS,
        name: SERVICE_TITLE(SERVICE_DAYTRIPS),
    },
    {
        id: SERVICE_TOURS,
        name: SERVICE_TITLE(SERVICE_TOURS),
    },
    {
        id: SERVICE_INTERNATIONAL,
        name: SERVICE_TITLE(SERVICE_INTERNATIONAL),
    },
    {
        id: SERVICE_FLIGHTS,
        name: SERVICE_TITLE(SERVICE_FLIGHTS),
    },
    // {
    //     id : SERVICE_PACKAGED,
    //     name: SERVICE_TITLE(SERVICE_PACKAGED),
    // },
    {
        id: SERVICE_TRANSFERS,
        name: SERVICE_TITLE(SERVICE_TRANSFERS),
    },
    {
        id: SERVICE_OTHERS,
        name: SERVICE_TITLE(SERVICE_OTHERS),
    },
    {
        id: SERVICE_LOCKEDS,
        name: SERVICE_TITLE(SERVICE_LOCKEDS),
    },
    {
        id: SERVICE_GROUPS,
        name: SERVICE_TITLE(SERVICE_GROUPS),
    },
];